const updatePassword = {
    "d": {
        IsSuccess: true
    }
};
export default updatePassword;